<template>
  <div>
    <Header />
    <main role="main">
      <b-container class="user py-3">
        <b-row>
          <b-col md="3">
            <div class="box">
              <div class="user__avatar text-center py-5">
                <b-img :src="require('@/assets/images/default_avatar.png')" rounded="circle" alt="Circle image"></b-img>
                <h4 class="mt-3">{{ user.name }}</h4>
                <h6 class="mt-3 user__avatar_email">{{ user.email }}</h6>
              </div>
            </div>
          </b-col>
          <b-col md="9">
            <slot />
          </b-col>
        </b-row>
      </b-container>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { mapState } from 'vuex'

export default {
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapState('auth', ['user'])
  }
}
</script>